module.exports = __webpack_public_path__ + "static/orc_eye_of_gruumsh-d25e828bbac538d16556a943dc6589cf.jpg";